import render from 'preact-render-to-string';
import { useEffect, useState } from 'preact/hooks';
import { Link, route } from 'preact-router';
import useAnimals from '../context/AppContext';
import Table from '../components/ui/Table';
import sexItems from '../consts';

export default function Location({ id }) {
    const { locations, animals, events } = useAnimals();
    if (!locations || !animals || !events) return (<div>Loading ...</div>);
    const location = locations.find(location => parseInt(location.id) === parseInt(id));
    const currentAnimals = animals.filter(animal => {
        if (!animal.location) return false;
        return parseInt(animal.location.id) === parseInt(id);
    });
    const [grazingPressure, setGrazingPressure] = useState([]);
    const [maxGrazingPressure, setMaxGrazingPressure] = useState(0);

    const getDaysInMonth = (date) => {
        return new Date(date.getYear(), date.getMonth() + 1, 0).getDate();
    }

    const getAnimalPresence = (events, locationId) => {
        let movements = events.filter(evt => parseInt(evt.type) === 1);
        let prev = [];
        const animalPresence = [];
        movements.forEach(evt => {
            let d2;
            let d1 = new Date(evt.dateApi);
            if (!prev[evt.animalId]) {
                d2 = new Date();
                prev[evt.animalId] = [];
            } else {
                d2 = new Date(prev[evt.animalId][prev[evt.animalId].length - 1].dateApi);
            }
            if (evt.locationId == locationId) {
                animalPresence.push({
                    animalId: evt.animalId,
                    locationId: evt.locationId,
                    d1,
                    d2
                });
            }
            prev[evt.animalId].push(evt);
        })
        return animalPresence;
    }

    const getGrazingPressure = function (animalPresence) {
        let gpList = [];
        // 2 years history
        for (let mth = 0; mth < 24; mth++) {
            let date = new Date();
            date.setMonth(date.getMonth() - mth, 1);          
            let nbDaysInMonth = getDaysInMonth(date);
            let dateString = date.toLocaleDateString();
            if (!gpList[dateString]) gpList[dateString] = { date, presence: [], average: 0 };
            let gp = gpList[dateString];
            for (let day = 1; day <= nbDaysInMonth; day++) {
                date.setDate(day);
                animalPresence.forEach(presence => {
                    if (date >= presence.d1 && date <= presence.d2) {
                        if (!gp.presence[day]) gp.presence[day] = 0
                        gp.presence[day] += 1;
                    }
                })
            }
            let nbDays = nbDaysInMonth;
            // If the date is in the current month divide by the current day
            if (new Date().toLocaleDateString().substring(3) == dateString.substring(3)) {
                nbDays = new Date().getDate();
            }
            gp.average = Math.round(gp.presence.reduce((pSum, p) => pSum + p, 0) / nbDays);
        }
        return Object.values(gpList);
    }

    useEffect(() => {
        const gpList = getGrazingPressure(getAnimalPresence(events, id));
        let maxGP = 0;
        gpList.forEach(gp => {
            if (gp.average > maxGP) maxGP = gp.average;
        });
        gpList.reverse();
        setGrazingPressure(gpList);
        setMaxGrazingPressure(maxGP);
    }, [events]);

    const columnsGP = [
        { label: "Date", accessor: "date", sortable: false },
        { label: "Nombre", accessor: "presence", sortable: false },
    ];

    const columns = [
        { label: "Nom", accessor: "name", sortable: false },
        { label: "Sexe", accessor: "sex", sortable: false },
        { label: "Suitee", accessor: "followed", sortable: false },
    ];

    function gotoEdit() {
        route('/form-location/' + location.id);
    }

    const cellFormatGP = function (value, accessor, data) {
        return value;
    }

    const cellFormat = function (value, accessor, data) {
        let str = value;
        if (accessor == 'sex') {
            str = sexItems[value];
        } else if (accessor == 'name') {
            str = render(<Link href={'/animal/' + data.id}>{value}</Link>);
            data.markers.forEach(marker => {
                str += '<div class="marker-shape" style="background-color:' + marker.color + '"></div>';
            })
        }
        return str;
    }

    return (
        <div class="container-md mt-2 detail">
            <h1 class="text-center position-fixed bg-white w-100" style="margin-left: -0.75rem !important;">{location.name}</h1>
            <div className="p-3 pt-5">
                <div class="p-3 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    Commune : {location.city}
                </div>
                <div class="p-3 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    Adresse : {location.address}
                </div>
                <div class="p-3 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    Contact : {location.contact}
                </div>
                <div class="p-3 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    Surface : {location.surface} m2
                </div>
                <div class="p-3 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    Propriétaire : {location.owner}
                </div>
                <div class="p-3 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    Date de prochaine intervention : {new Date(location.nextInterventionDateApi).toLocaleDateString()}
                </div>
                <div style={{ whiteSpace: "pre-wrap" }} class="p-3 bg-light-subtle bg-opacity-10 border border-light-subtle">
                    Notes : {location.notes}
                </div>
                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <input class="action-button btn btn-primary btn-lg" type="button" value="Editer" onClick={gotoEdit} />
                </div>
                {grazingPressure.length > 0 &&
                    <div class="mt-4 mb-4" id="gp">
                        <h2>Pression de paturage</h2>
                        {localStorage.getItem('displayArchive') != "true" && <div class="alert alert-warning" role="alert">Pensez à activer les archives dans le menu pour avoir toutes les données.</div>}
                        {/* <Table id="grazingPressure" caption="Pression paturage" columns={columnsGP} selectable={false} data={grazingPressure} cellFormat={cellFormatGP} /> */}
                        <div class="chart-container">
                            <div class="chart">
                                <div class="bottom"></div>
                                {grazingPressure.map((gp) => {
                                    return (<div style={"height:" + (Math.round(gp.average / maxGrazingPressure * 100)) + "%;"}><div class="presence">{gp.average > 0 && gp.average}</div><div class="date">{gp.date.getMonth() + 1}<br />{gp.date.getFullYear().toString().substring(2)}</div></div>)
                                })}
                            </div>
                        </div>
                    </div>
                }
                <div class="mt-4">
                    {currentAnimals.length > 0 && <Table id="animals" caption="Animaux présents" columns={columns} selectable={false} data={currentAnimals} cellFormat={cellFormat} />}
                </div>
            </div>
        </div >
    );
}